<div *ngIf="visible" class="affiliate-cta">
    <a class="affiliate-cta__link" [href]="affiliateUrl" target="_blank" rel="noopener sponsored"
        (click)="trackClick()">
        <span class="affiliate-cta__text">
            <ng-container i18n="@@affiliateMondayCta">Where does the estimate go next? Many teams track their backlog in monday.com.</ng-container>
            <span class="affiliate-cta__action"><ng-container i18n="@@affiliateCtaAction">Take a look</ng-container>&nbsp;→</span>
        </span>
        <span class="affiliate-cta__ad-label" i18n="@@affiliateAdLabel">Ad</span>
    </a>
</div>
